import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { Icon } from "@iconify/react";

import {
  BigText,
  btnfont,
  DarkBold,
  LighterBold,
  Lightly,
} from "../../Assets/CSS/Text";

import { Newbtn } from "../../Assets/CSS/Button";

function Tenent() {
  const navigate = useNavigate();

  const [tenantList, setTenantList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const token = localStorage.getItem("token");

  // Fetch Tenants
  useEffect(() => {
    fetchTenants();
  }, []);

  const fetchTenants = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/tenants`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response?.data);

      setTenantList(response?.data?.content || []);
    } catch (error) {
      console.error("Error fetching tenants:", error);
    } finally {
      setLoading(false);
    }
  };

  // Delete Tenant
  const handleDelete = async (tenantId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this tenant?"
    );

    if (!confirmDelete) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/tenants/${tenantId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      fetchTenants();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const filteredTenants = tenantList.filter((tenant) =>
    tenant?.tenantName
      ?.toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  return (
    <Layout>
      <div className="backgound-main-content p-3">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 style={BigText}>Tenants</h2>

          <button
            style={{ ...btnfont, ...Newbtn }}
            onClick={() => navigate("/createTenant")}
          >
            <Icon icon="material-symbols:add-rounded" width="18" height="18" />
            New Tenant
          </button>
        </div>

        {/* Search */}
        <div className="timesheet-controls">
          <div className="search-bar" style={{ boxShadow: "none" }}>
            <input
              type="text"
              className="form-control border-0"
              placeholder="Search tenant"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            <Icon
              icon="iconamoon:search"
              width="20"
              height="20"
              color="rgba(0, 175, 239, 1)"
            />
          </div>
        </div>

        {/* Table */}
        <div className="timesheet-table mb-4 table-responsive">
          <table className="employee-table timesheet-table">
            <thead>
              <tr>
                <th style={LighterBold}>Tenant Name</th>
                <th style={LighterBold}>Email</th>
                <th style={LighterBold}>Mobile</th>
                <th style={LighterBold}>Tenant Type</th>
                <th style={LighterBold}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading
                ? Array.from({ length: 5 }).map((_, index) => (
                    <tr key={index}>
                      <td><Skeleton width={120} /></td>
                      <td><Skeleton width={150} /></td>
                      <td><Skeleton width={100} /></td>
                      <td><Skeleton width={80} /></td>
                      <td><Skeleton width={60} /></td>
                    </tr>
                  ))
                : filteredTenants.map((tenant, index) => (
                    <tr key={index}>
                      <td style={DarkBold}>{tenant?.tenantName}</td>

                      <td style={Lightly}>{tenant?.email}</td>

                      <td style={Lightly}>
                        {tenant?.countryCode} {tenant?.mobileNumber}
                      </td>

                      <td style={Lightly}>{tenant?.tenantType}</td>

                      <td className="d-flex gap-3">
                        {/* View */}
                        <Icon
                          icon="hugeicons:view"
                          style={{
                            color: "#00AFEF",
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigate(`/tenantView/${tenant?.tenantId}`)
                          }
                        />

                        {/* Edit */}
                        <Icon
                          icon="tabler:edit"
                          style={{
                            color: "#EAA700",
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigate(`/editTenant/${tenant?.tenantId}`)
                          }
                        />

                        {/* Delete */}
                        <Icon
                          icon="material-symbols:delete-outline"
                          style={{
                            color: "#DD0000",
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleDelete(tenant?.tenantId)
                          }
                        />
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}

export default Tenent;